import { getLoyaltyLevelText } from 'components/ReusableComponents/Arrivals/LoyaltyIcon/helpers'
import HiltonDiamond from 'components/ReusableComponents/Arrivals/LoyaltyIcon/hilton/diamond'
import HiltonGold from 'components/ReusableComponents/Arrivals/LoyaltyIcon/hilton/gold'
import HiltonMember from 'components/ReusableComponents/Arrivals/LoyaltyIcon/hilton/member'
import HiltonSilver from 'components/ReusableComponents/Arrivals/LoyaltyIcon/hilton/silver'
import { loyaltyProgramLevels } from 'components/ReusableComponents/Arrivals/LoyaltyIcon/loyaltyLevels'
import { parentChains } from 'main/hotelBrandsAndChains'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { useSelector } from 'react-redux'

import LoyaltyTooltip from '../LoyaltyTooltip/index'
import bwBase from './bestwestern/base.svg'
import bwBlue from './bestwestern/blue.svg'
import bwDiamondSelect from './bestwestern/diamond-select.svg'
import bwDiamond from './bestwestern/diamond.svg'
import bwGold from './bestwestern/gold.svg'
import bwPlatinum from './bestwestern/platinum.svg'
import diamondIcon from './choice/diamond.png'
import goldIcon from './choice/gold.png'
import noRank from './choice/noRank.png'
import platinumIcon from './choice/platinum.png'
import discoverist from './Hyatt/Discoverist.svg'
import explorist from './Hyatt/Explorist.svg'
import globalist from './Hyatt/Globalist.svg'
import lifetimeGlobalist from './Hyatt/Lifetime-globalist.svg'
import member from './Hyatt/Member.svg'
import ihgClub from './ihg/Club.svg'
import ihgGold from './ihg/Gold.svg'
import ihgPlatinum from './ihg/Platinum.svg'
import ihgSpire from './ihg/Spire.svg'
import styles from './LoyaltyIcon.module.scss'
import marriottAmbassador from './marriott/Ambassador.svg'
import marriottGold from './marriott/Gold.svg'
import marriottMember from './marriott/Member.svg'
import marriottPlatinum from './marriott/Platinum.svg'
import marriottSilver from './marriott/Silver.svg'
import marriottTitanium from './marriott/Titanium.svg'
import radissonClub from './Radisson/club.svg'
import radissonGold from './Radisson/gold.svg'
import radissonPlatinum from './Radisson/platinum.svg'
import radissonSilver from './Radisson/silver.svg'
import sonestaBronze from './sonesta/bronze.svg'
import sonestaGold from './sonesta/gold.svg'
import sonestaPlatinum from './sonesta/platinum.svg'
import sonestaSilver from './sonesta/silver.svg'
import sonestaMember from './sonesta/travelpass.svg'
import wyndhamBlue from './wyndham/Blue.svg'
import wyndhamDiamond from './wyndham/Diamond.svg'
import wyndhamGold from './wyndham/Gold.svg'
import wyndhamPlatinum from './wyndham/Platinum.svg'
import wyndhamTitanium from './wyndham/Titanium.svg'

const LoyaltyIcon = ({ loyaltyLevel, loyaltyProgram, className }) => {
  const parentChainCode = useSelector(s => s.hotelDetails.parentChainCode)

  const props = { loyaltyLevel, loyaltyProgram, className }

  switch (parentChainCode) {
    case parentChains.choice:
      return <ChoiceLoyaltyIcon {...props} />

    case parentChains.ihg:
      return <IHGLoyaltyIcon {...props} />

    case parentChains.wyndham:
      return <WyndhamLoyaltyIcon {...props} />

    case parentChains.hyatt:
      return <HyattLoyaltyIcons {...props} />

    case parentChains.radisson:
      return <RadissonIcon {...props} />

    case parentChains.marriott:
      return <MarriottLoyaltyIcon {...props} />

    case parentChains.bestwestern:
      return <BestWesternLoyaltyIcon {...props} />

    case parentChains.hilton:
      return <HiltonLoyaltyIcon {...props} />

    case parentChains.sonesta:
      return <SonestaLoyaltyIcon {...props} />

    default:
      return null
  }
}

const SonestaLoyaltyIcon = ({ loyaltyLevel, loyaltyProgram, className }) => {
  const [showLoyaltyTooltip, setShowLoyaltyTooltip] = useState(false)

  function getIcon() {
    if (loyaltyProgram) {
      if (loyaltyLevel === loyaltyProgramLevels.sonesta.TRAVELPASS) {
        return <img src={sonestaMember} alt={loyaltyLevel} />
      }

      if (loyaltyLevel === loyaltyProgramLevels.sonesta.SILVER) {
        return <img src={sonestaSilver} alt={loyaltyLevel} />
      }

      if (loyaltyLevel === loyaltyProgramLevels.sonesta.BRONZE) {
        return <img src={sonestaBronze} alt={loyaltyLevel} />
      }

      if (loyaltyLevel === loyaltyProgramLevels.sonesta.GOLD) {
        return <img src={sonestaGold} alt={loyaltyLevel} />
      }

      if (loyaltyLevel === loyaltyProgramLevels.sonesta.PLATINUM) {
        return <img src={sonestaPlatinum} alt={loyaltyLevel} />
      }
    }

    return null
  }

  if (!loyaltyProgram) {
    return null
  }

  return (
    <>
      {getIcon && showLoyaltyTooltip && (
        <LoyaltyTooltip loyaltyProgram={loyaltyProgram} loyaltyLevel={loyaltyLevel} />
      )}
      <span
        className={[styles.loyaltyIcon, className].join(' ')}
        onMouseEnter={() => setShowLoyaltyTooltip(true)}
        onMouseLeave={() => setShowLoyaltyTooltip(false)}
      >
        {getIcon()}
      </span>
    </>
  )
}

const HiltonLoyaltyIcon = ({ loyaltyLevel, loyaltyProgram, className }) => {
  const [showLoyaltyTooltip, setShowLoyaltyTooltip] = useState(false)

  function getIcon() {
    if (loyaltyProgram) {
      if (loyaltyLevel === loyaltyProgramLevels.hilton.Member) {
        return <HiltonMember />
      }

      if (loyaltyLevel === loyaltyProgramLevels.hilton.Silver) {
        return <HiltonSilver />
      }

      if (loyaltyLevel === loyaltyProgramLevels.hilton.Gold) {
        return <HiltonGold />
      }

      if (loyaltyLevel === loyaltyProgramLevels.hilton.Diamond) {
        return <HiltonDiamond />
      }
    }

    return null
  }

  if (!loyaltyProgram) {
    return null
  }

  return (
    <>
      {getIcon && showLoyaltyTooltip && (
        <LoyaltyTooltip loyaltyProgram={loyaltyProgram} loyaltyLevel={loyaltyLevel} />
      )}
      <span
        className={[styles.loyaltyIcon, styles.loyaltyIconHilton, className].join(' ')}
        onMouseEnter={() => setShowLoyaltyTooltip(true)}
        onMouseLeave={() => setShowLoyaltyTooltip(false)}
      >
        {getIcon()}
      </span>
    </>
  )
}

const MarriottLoyaltyIcon = ({ loyaltyLevel, loyaltyProgram, className }) => {
  const [showLoyaltyTooltip, setShowLoyaltyTooltip] = useState(false)

  function getIcon() {
    if (loyaltyProgram) {
      if (loyaltyLevel === loyaltyProgramLevels.marriott.Member) {
        return <img src={marriottMember} alt={loyaltyLevel} />
      }

      if (loyaltyLevel === loyaltyProgramLevels.marriott['Silver Elite']) {
        return <img src={marriottSilver} alt={loyaltyLevel} />
      }

      if (loyaltyLevel === loyaltyProgramLevels.marriott['Gold Elite']) {
        return <img src={marriottGold} alt={loyaltyLevel} />
      }

      if (loyaltyLevel === loyaltyProgramLevels.marriott['Platinum Elite']) {
        return <img src={marriottPlatinum} alt={loyaltyLevel} />
      }

      if (loyaltyLevel === loyaltyProgramLevels.marriott['Titanium Elite']) {
        return <img src={marriottTitanium} alt={loyaltyLevel} />
      }

      if (loyaltyLevel === loyaltyProgramLevels.marriott['Ambassador Elite']) {
        return <img src={marriottAmbassador} alt={loyaltyLevel} />
      }
    }
  }

  if (!loyaltyProgram) {
    return null
  }

  return (
    <>
      {getIcon && showLoyaltyTooltip && (
        <LoyaltyTooltip
          loyaltyProgram={loyaltyProgram}
          loyaltyLevel={getLoyaltyLevelText(parentChains.marriott, loyaltyLevel)}
        />
      )}
      <span
        className={[styles.loyaltyIcon, styles.loyaltyIconMarriott, className].join(' ')}
        onMouseEnter={() => setShowLoyaltyTooltip(true)}
        onMouseLeave={() => setShowLoyaltyTooltip(false)}
      >
        {getIcon()}
      </span>
    </>
  )
}

const RadissonIcon = ({ loyaltyLevel, loyaltyProgram, className }) => {
  const [showLoyaltyTooltip, setShowLoyaltyTooltip] = useState(false)

  function getIcon() {
    if (loyaltyProgram) {
      if (loyaltyLevel === loyaltyProgramLevels.radisson.CLUB) {
        return <img src={radissonClub} alt={loyaltyLevel} />
      }

      if (loyaltyLevel === loyaltyProgramLevels.radisson.SILVER) {
        return <img src={radissonSilver} alt={loyaltyLevel} />
      }

      if (loyaltyLevel === loyaltyProgramLevels.radisson.PLATINUM) {
        return <img src={radissonPlatinum} alt={loyaltyLevel} />
      }

      if (loyaltyLevel === loyaltyProgramLevels.radisson.GOLD) {
        return <img src={radissonGold} alt={loyaltyLevel} />
      }
    }

    return null
  }

  if (!loyaltyProgram) {
    return null
  }

  return (
    <>
      {getIcon && showLoyaltyTooltip && (
        <LoyaltyTooltip
          loyaltyProgram={loyaltyProgram}
          loyaltyLevel={getLoyaltyLevelText(parentChains.radisson, loyaltyLevel)}
        />
      )}
      <span
        className={[styles.loyaltyIcon, styles.loyaltyIconIHG, className].join(' ')}
        onMouseEnter={() => setShowLoyaltyTooltip(true)}
        onMouseLeave={() => setShowLoyaltyTooltip(false)}
      >
        {getIcon()}
      </span>
    </>
  )
}

const IHGLoyaltyIcon = ({ loyaltyLevel, loyaltyProgram, className }) => {
  const [showLoyaltyTooltip, setShowLoyaltyTooltip] = useState(false)

  function getIcon() {
    if (loyaltyProgram) {
      if (loyaltyLevel === loyaltyProgramLevels.ihg.CLUB) {
        return <img src={ihgClub} alt={loyaltyLevel} />
      }

      if (loyaltyLevel === loyaltyProgramLevels.ihg.GOLD) {
        return <img src={ihgGold} alt={loyaltyLevel} />
      }

      if (loyaltyLevel === loyaltyProgramLevels.ihg.PLATINUM) {
        return <img src={ihgPlatinum} alt={loyaltyLevel} />
      }

      if (loyaltyLevel === loyaltyProgramLevels.ihg.SPIRE) {
        return <img src={ihgSpire} alt={loyaltyLevel} />
      }
    }

    return null
  }

  if (!loyaltyProgram) {
    return null
  }

  return (
    <>
      {getIcon && showLoyaltyTooltip && (
        <LoyaltyTooltip
          loyaltyProgram={loyaltyProgram}
          loyaltyLevel={getLoyaltyLevelText(parentChains.ihg, loyaltyLevel)}
        />
      )}
      <span
        className={[styles.loyaltyIcon, styles.loyaltyIconIHG, className].join(' ')}
        onMouseEnter={() => setShowLoyaltyTooltip(true)}
        onMouseLeave={() => setShowLoyaltyTooltip(false)}
      >
        {getIcon()}
      </span>
    </>
  )
}

const HyattLoyaltyIcons = ({ loyaltyLevel, loyaltyProgram, className }) => {
  const [showLoyaltyTooltip, setShowLoyaltyTooltip] = useState(false)

  function getIcon() {
    if (loyaltyProgram) {
      if (loyaltyLevel === loyaltyProgramLevels.hyatt.MEMB) {
        return <img src={member} alt={loyaltyLevel} />
      }

      if (loyaltyLevel === loyaltyProgramLevels.hyatt.DISV) {
        return <img src={discoverist} alt={loyaltyLevel} />
      }

      if (loyaltyLevel === loyaltyProgramLevels.hyatt.EXPL) {
        return <img src={explorist} alt={loyaltyLevel} />
      }

      if (loyaltyLevel === loyaltyProgramLevels.hyatt.GLOB) {
        return <img src={globalist} alt={loyaltyLevel} />
      }

      if (loyaltyLevel === loyaltyProgramLevels.hyatt.LGLO) {
        return <img src={lifetimeGlobalist} alt={loyaltyLevel} />
      }
    }

    return null
  }

  if (!loyaltyProgram) {
    return null
  }

  return (
    <>
      {getIcon && showLoyaltyTooltip && (
        <LoyaltyTooltip
          loyaltyProgram={loyaltyProgram}
          loyaltyLevel={getLoyaltyLevelText(parentChains.hyatt, loyaltyLevel)}
        />
      )}
      <span
        className={[styles.loyaltyIcon, styles.loyaltyIconIHG, className].join(' ')}
        onMouseEnter={() => setShowLoyaltyTooltip(true)}
        onMouseLeave={() => setShowLoyaltyTooltip(false)}
      >
        {getIcon()}
      </span>
    </>
  )
}

const WyndhamLoyaltyIcon = ({ loyaltyLevel, loyaltyProgram, className }) => {
  const [showLoyaltyTooltip, setShowLoyaltyTooltip] = useState(false)

  function getIcon() {
    if (loyaltyProgram) {
      if (loyaltyLevel === loyaltyProgramLevels.wyndham.BLUE) {
        return <img src={wyndhamBlue} alt={loyaltyLevel} />
      }

      if (loyaltyLevel === loyaltyProgramLevels.wyndham.GOLD) {
        return <img src={wyndhamGold} alt={loyaltyLevel} />
      }

      if (loyaltyLevel === loyaltyProgramLevels.wyndham.DIAMOND) {
        return <img src={wyndhamDiamond} alt={loyaltyLevel} />
      }

      if (loyaltyLevel === loyaltyProgramLevels.wyndham.PLATINUM) {
        return <img src={wyndhamPlatinum} alt={loyaltyLevel} />
      }

      if (loyaltyLevel === loyaltyProgramLevels.wyndham.TITATIUM) {
        return <img src={wyndhamTitanium} alt={loyaltyLevel} />
      }
    }

    return null
  }

  if (!loyaltyProgram) {
    return null
  }

  return (
    <>
      {getIcon && showLoyaltyTooltip && (
        <LoyaltyTooltip
          loyaltyProgram={loyaltyProgram}
          loyaltyLevel={getLoyaltyLevelText(parentChains.wyndham, loyaltyLevel)}
        />
      )}
      <span
        className={[styles.loyaltyIcon, styles.loyaltyIconIHG, className].join(' ')}
        onMouseEnter={() => setShowLoyaltyTooltip(true)}
        onMouseLeave={() => setShowLoyaltyTooltip(false)}
      >
        {getIcon()}
      </span>
    </>
  )
}

const ChoiceLoyaltyIcon = ({ loyaltyLevel, loyaltyProgram, className }) => {
  const [showLoyaltyTooltip, setShowLoyaltyTooltip] = useState(false)

  function getIcon() {
    if (loyaltyProgram) {
      if (loyaltyLevel === loyaltyProgramLevels.choice['Elite Gold']) {
        return <img src={goldIcon} alt="Gold level" />
      }

      if (loyaltyLevel === loyaltyProgramLevels.choice['Elite Platinum']) {
        return <img src={platinumIcon} alt="Platinum level" />
      }

      if (loyaltyLevel === loyaltyProgramLevels.choice['Elite Diamond']) {
        return <img src={diamondIcon} alt="Diamond level" />
      }

      return <img src={noRank} alt="Choice Privileges Member" />
    }

    return null
  }

  if (!loyaltyProgram) {
    return <span className={[styles.loyaltyIcon, className].join(' ')}></span>
  }

  return (
    <>
      {getIcon && showLoyaltyTooltip && (
        <LoyaltyTooltip loyaltyProgram={loyaltyProgram} loyaltyLevel={loyaltyLevel} />
      )}
      <span
        className={[styles.loyaltyIcon, className].join(' ')}
        onMouseEnter={() => setShowLoyaltyTooltip(true)}
        onMouseLeave={() => setShowLoyaltyTooltip(false)}
      >
        {getIcon()}
      </span>
    </>
  )
}

const BestWesternLoyaltyIcon = ({ loyaltyLevel, loyaltyProgram, className }) => {
  const [showLoyaltyTooltip, setShowLoyaltyTooltip] = useState(false)

  function getIcon() {
    if (loyaltyLevel) {
      if (loyaltyLevel.toUpperCase() === loyaltyProgramLevels.bestwestern.BASE) {
        return <img src={bwBase} alt="Best Western Rewards member" />
      }

      if (loyaltyLevel.toUpperCase() === loyaltyProgramLevels.bestwestern.BLUE) {
        return <img src={bwBlue} alt="Blue" />
      }

      if (loyaltyLevel.toUpperCase() === loyaltyProgramLevels.bestwestern.GOLD) {
        return <img src={bwGold} alt="Gold" />
      }

      if (loyaltyLevel.toUpperCase() === loyaltyProgramLevels.bestwestern.SILVER) {
        return <img src={bwPlatinum} alt="Silver" />
      }

      if (loyaltyLevel.toUpperCase() === loyaltyProgramLevels.bestwestern.DIAMOND) {
        return <img src={bwDiamond} alt="Diamond" />
      }

      if (
        loyaltyLevel.toUpperCase() === loyaltyProgramLevels.bestwestern['DIAMOND SELECT']
      ) {
        return <img src={bwDiamondSelect} alt="Diamond Select" />
      }
    }

    return null
  }

  if (!loyaltyProgram) {
    return <span className={[styles.loyaltyIcon, className].join(' ')}></span>
  }

  return (
    <>
      {getIcon && showLoyaltyTooltip && (
        <LoyaltyTooltip
          loyaltyProgram={loyaltyProgram}
          loyaltyLevel={getLoyaltyLevelText(parentChains.bestwestern, loyaltyLevel)}
        />
      )}
      <span
        className={[styles.loyaltyIcon, className].join(' ')}
        onMouseEnter={() => setShowLoyaltyTooltip(true)}
        onMouseLeave={() => setShowLoyaltyTooltip(false)}
      >
        {getIcon()}
      </span>
    </>
  )
}

LoyaltyIcon.prototypes = {
  loyaltyLevel: PropTypes.string,
  loyaltyProgram: PropTypes.string
}

export default LoyaltyIcon
